export default {
  home: 'Home',
  aboutUs: 'About US',
  productService: 'Products & Services',
  claims: 'Claims',
  questions: 'FAQ',
  contactUs: 'Contact US',
  privacyPolicy: 'Privacy Policy',
  termsUse: 'Terms of Use',
  login: 'Log In',
  copyRight: function() { return '© ' + new Date().getFullYear() + ' Assura Asia. All Rights Reserved.'; },
  checkmore: 'MORE',
  slogan: [ 'Aesthetic Risk Coverage', 'Confidence When It Matters' ],
  contact: 'Contact',
  back: 'Back',
  userName: 'Username',
  account: 'Account',
  email: 'Email',
  password: 'Password',
  scroll: 'SCROLL',
  backtohome: 'Return to Home',
  iknowle: 'Got it',
  backtotop: 'TOP',

  // 首页
  home_aboutUs: 'About US',
  home_aboutUs_desc: `Assura Asia, a wholly owned subsidiary of Switzerland's Assura Group established in 2025, specializes in providing premium insurance solutions for medical aesthetics institutions and individuals across the Asia-Pacific region, positioning itself as a leading innovator in the industry.`,
  home_productService: 'Products & Services',
  home_productService_desc: 'We provide personalized coverage options to prevent and address potential risks, while actively driving the high-quality development of the Asia-Pacific medical aesthetics industry.',
  home_policyExchange: 'Redeem',
  home_claims: 'Claims',
  home_claims_desc: 'Access seamless and efficient claims anytime, anywhere via our online platform or dedicated advisors.',

  // 关于我们
  aboutus_aboutUs: 'About US',
  aboutus_aboutUs_desc: `Founded in 2025 by Switzerland's Assura Asia Group, Assura Asia is a leading provider of innovative insurance solutions tailored for medical aesthetics in the Asia-Pacific region. As a leader in innovative, specialized insurance, we offer comprehensive and reliable coverage.

As medical aesthetics technology advances, our business has grown rapidly. By continuously enhancing our products and services, we ensure safe, efficient, and reliable protection for both existing and future clients.`,
  aboutus_mission: 'Mission & Values',
  aboutus_mission_desc: `Our mission and values are embodied in both our operations and management, 
with <em>mutual respect</em> and <em>the pursuit of excellence</em> forming the core of Assura Asia.`,
  aboutus_mission_1_title: `Customer First`,
  aboutus_mission_1_desc1: `Customer satisfaction defines our success.`,
  aboutus_mission_1_desc2: `In every situation, we prioritize understanding our clients' needs and providing effective support—an unwavering principle at the core of our business.`,
  aboutus_mission_2_title: `Clarity in Perspective`,
  aboutus_mission_2_desc1: `Life’s complexities demand thoughtful discernment. `,
  aboutus_mission_2_desc2: `We embrace every opportunity and navigate every risk with balanced insight, crafting decisions that blend human empathy with rational judgment.`,
  aboutus_mission_3_title: `Harmony in Unity`,
  aboutus_mission_3_desc1: `A thriving enterprise is a symphony of collaboration and respect.`,
  aboutus_mission_3_desc2: `We cultivate an environment where excellence leads, offering equal opportunities for talent to flourish in comfort and dignity.`,
  aboutus_mission_4_title: `Pride in Citizenship`,
  aboutus_mission_4_desc1: `We take pride in being a responsible corporate citizen.`,
  aboutus_mission_4_desc2: `Committed to giving back to society, we actively support diverse social initiatives. Our strategic realignment signifies AA's new positioning in the Asian market. Even in the face of future uncertainties, we remain steadfast in our dedication and effort.`,
  aboutus_leadership: 'Leadership',
  aboutus_leadership_desc: `Together with our experienced colleagues, we confront the unknown challenges, 
striving to maximize the <em>creation of the social value</em> we envision`,
  aboutus_leadership_1_name: [ 'Bharat W. Lester', 'Bharat W. Lester' ],
  aboutus_leadership_1_poi: 'CEO',
  aboutus_leadership_1_desc: `Mr. Bharat is the Chief Executive Officer of Assura Asia. 
With over 20 years of experience in the insurance industry, he has been instrumental in establishing and executing the Swiss headquarters' business and development strategy in the Asia-Pacific region since 2025. Prior to joining the Swiss parent company, Mr. Bharat worked at the Swiss National Science Foundation (SNSF), managing operations and initiatives in the field of medical aesthetics. He later gained extensive senior management experience at companies such as Cigna Global and Prudential Insurance.`,
  aboutus_leadership_2_name: [ 'Max Lee', 'Max Lee' ],
  aboutus_leadership_2_poi: 'CRO',
  aboutus_leadership_2_desc: `Mr. Max Lee is the Chief Risk Officer at Assura Asia, overseeing risk management, compliance, and legal affairs. With over 15 years of experience in the Asia-Pacific and international insurance markets, his expertise spans actuarial, reserves, and financial control. Mr. Lee holds a Ph.D. in Economics from Seoul National University.`,
  aboutus_leadership_3_name: [ 'Cathy Ng', 'Cathy Ng' ],
  aboutus_leadership_3_poi: 'CFO',
  aboutus_leadership_3_desc: `Ms. Cathy Ng is the Chief Financial Officer at Assura Asia, overseeing financial reporting, planning, and management. She joined the Swiss headquarters in 2015 and serves as a director for several subsidiaries. With over 15 years of industry experience, Ms. Ng previously held a senior management role at Ernst & Young. She holds a Bachelor's in Accounting from the National University of Singapore and an MBA from Stanford University.`,
  aboutus_leadership_4_name: [ 'Aaron Lim', 'Aaron Lim' ],
  aboutus_leadership_4_poi: 'VP of Business, Asia-Pacific',
  aboutus_leadership_4_desc: `Mr. Aaron Lim is the Vice President of Business Development for Assura Asia in the Asia-Pacific region, responsible for managing product and business development. He joined the company in 2021 and brings over 15 years of senior management experience. Prior to joining Assura Asia, Mr. Lim worked at Allergan's Asia-Pacific headquarters, with extensive networks and resources in the medical aesthetics industry. He holds a Bachelor's degree from the Chinese University of Hong Kong.`,
  aboutus_leadership_5_name: [ 'Satomi Nagano', 'Satomi Nagano' ],
  aboutus_leadership_5_poi: 'VP of Human Resources, Asia-Pacific',
  aboutus_leadership_5_desc: `Ms. Satomi Nagano is the Vice President of Human Resources for Assura Asia in the Asia-Pacific region, responsible for driving HR strategies to achieve growth objectives. She joined the company in 2025 and has created significant value across operations, R&D, and business development, continuously identifying and nurturing top talent and business partners for regional subsidiaries. Ms. Nagano holds an MBA from the University of Tokyo.`,
  aboutus_corporate: 'Corporate Responsibility',
  aboutus_corporate_desc: `For years, 
  Assura Asia has helped reduce risks for patients and businesses,
  driving industry growth.
  We also inspire our partners, inside and out, 
  to make the world <em>a better place through love and care</em>.`,
  aboutus_corporate_1_title: `Health Empowerment`,
  aboutus_corporate_1_desc: `By forging long-term partnerships with charitable organizations and teams, we are dedicated to driving positive social change and progress.`,
  aboutus_corporate_2_title: `Community Care`,
  aboutus_corporate_2_desc: `Through supporting education, environmental protection, healthcare, and volunteerism, we seek to enhance the overall well-being of communities.`,
  aboutus_corporate_3_title: `Environmental Protection`,
  aboutus_corporate_3_desc: `By reducing pollution, conserving resources, and advancing sustainable development and green energy projects, we aim to mitigate our environmental impact.`,
  aboutus_joinus: `Careers`,
  aboutus_joinus_title: `JOIN
  US`,
  mobile_aboutus_joinus_title: `JOIN US`,
  aboutus_joinus_intro1: `Assura Asia  operates across Singapore, Hong Kong, Indonesia, Malaysia, Thailand, South Korea, and Japan in the Asia-Pacific region. We plan to expand into more countries soon, and attracting top talent is crucial to our continued growth.

We actively seek qualified candidates through various channels. In addition to required experience and qualifications, our ideal candidates will have strong communication skills, effective writing abilities, and exceptional teamwork.`,
  aboutus_joinus_intro2: `* Assura Asia  is an equal opportunity employer. We do not discriminate against any qualified applicants based on race, color, religion, gender, pregnancy, nationality, age, marital status, sexual orientation, gender identity, disability, medical condition, genetic information, military status, or any other protected category. We comply with all applicable laws and provide reasonable accommodations for applicants with disabilities when needed.
  
  <span class="bold ffen">For inquiries or to learn more about open positions on third-party platforms, please feel free to send your detailed resume to: </span>
<span class="link ffen">career@assuraasia.com</span>`,

  // 产品与服务
  productservice_productService: `Products & Services`,
  productservice_productService_desc: `Cosmetic surgery is one of the most effective medical techniques for enhancing appearance and body contours. However, its invasive nature inevitably carries risks and potential complications.

We offer tailored, compassionate insurance solutions to better prevent and address unforeseen incidents. At the same time, advancing the high-quality development of the medical aesthetics industry across the Asia-Pacific region remains a core part of our mission.`,

  productservice_coveragePlans: `Coverage Plans`,
  productservice_coveragePlans_person: `Pre-Surgery Accident Coverage`,
  productservice_coveragePlans_person_desc: `Providing effective protection against unforeseen incidents with exceptional underwriting, market insights, and clinical expertise.`,
  productservice_coveragePlans_unit: `Institutional Liability Coverage`,
  productservice_coveragePlans_unit_desc: `Enhancing patient-institution relationships through innovative solutions while safeguarding reputation and mitigating financial risks.`,

  productservice_partners: `Partners`,
  productservice_partners_axa: `AXA`,
  productservice_partners_nissay: `NISSAY`,
  productservice_partners_hsbc: `HSBC`,
  productservice_partners_sl: `Singlife`,
  productservice_partners_aia: `AIA`,

  // 索偿
  claims_claims: `Claims`,
  claims_claims_desc: `Submit and track your claims anytime, anywhere through our online platform or with the assistance of your dedicated advisor.

We are committed to processing your claims promptly, offering sincere condolences and support throughout the process.`,
  claims_application_inquiry: `Application & Inquiry`,
  claims_application_inquiry_desc: `Quickly submit claims and track progress with convenient online self-service and dedicated advisor support to protect your rights.`,
  claims_application_inquiry_method1_title: `Online Self-Service`,
  claims_application_inquiry_method1_desc: `Access and manage your claims anytime, anywhere, simplifying the process.`,
  claims_application_inquiry_method2_title: `Dedicated Advisor Service`,
  claims_application_inquiry_method2_desc: `Connect with our customer service team instantly via our online contact platform to discuss your needs.`,
  claims_application_inquiry_login: 'Log in',

  // 常见问题
  faq_faqs: 'FAQs',
  faq_faqs_desc: `Explore answers to common questions about claims, policy benefits, and service details. 
  
Need more information? Contact us via the online form.`,
  faplist: [
    {
      question: `What is Medical Aesthetics? What are the Main Categories?`,
      ans: `Medical aesthetics involves enhancing, improving, repairing, or rejuvenating the appearance and shape of the body through surgical, pharmaceutical, or medical technologies, which may be invasive, minimally invasive, or non-invasive.

From a medical perspective, it can be divided into invasive procedures (cosmetic surgery) and non-invasive treatments (beauty light).

Invasive procedures include surgeries such as breast augmentation, liposuction, rhinoplasty, and eyelid surgery.
Non-invasive treatments involve techniques like laser therapy, radiofrequency skin tightening, and injectable treatments.`},
    {
      question: `What should I prepare before a medical aesthetic procedure?`,
      ans: `Before undergoing medical aesthetic procedures, we recommend the following steps:

Comprehensive Consultation: Seek detailed advice from professional medical institutions based on your individual needs and condition.
Mental Preparation: Be aware of and prepared for potential changes or impacts on your personal and professional life.
Choosing the Right Institution: Evaluate medical qualifications, reputation, physician expertise, services, and pricing to find the best fit.
Surgery Timing: Plan your surgery and recovery period carefully, avoiding pregnancy, breastfeeding, or menstruation cycles.
Health Checks: Conduct routine medical tests to rule out risks like hypertension, heart disease, or coagulation disorders.
Signing Agreements: Ensure the medical institution follows strict protocols and secure appropriate legal protections.
Insurance Coverage: Purchase insurance to manage unexpected medical expenses and emotional challenges effectively.`,
    },
    {
      question: `What is underwriting? What are its key processes?`,
      ans: `Underwriting is the process through which insurance companies assess the risks associated with offering coverage.

Typically, insurers collect personal health information, such as medical history and photos, to evaluate risk and decide whether to provide coverage and define its terms.`,
    },
    {
      question: `What is FASTPASS?`,
      ans: `In specific countries or regions, our data-driven approach enables simplified underwriting processes, significantly reducing the time required to purchase insurance.

Applicants simply answer basic questions during the application process, such as age, gender, residence, and health history. The entire process can take as little as five minutes, with no need for additional medical documentation.

This streamlined, automated approach follows strict principles of good faith and ensures policy approvals are faster compared to conventional methods.`,
    },
    {
      question: `Why is a health questionnaire required when applying for insurance?`,
      ans: `The company assesses the applicant's health status to estimate mortality, disability, and other risk factors. Based on this assessment, we determine eligibility and policy terms. The primary source of health information comes from health questionnaires, which must be completed truthfully by applicants.`,
    },
    {
      question: `What is the principle of utmost good faith?`,
      ans: `The principle of utmost good faith means the insurer relies on the accurate and honest disclosure of personal and health information by the applicant during underwriting. If the insurer later discovers that critical information was concealed or not disclosed, the claim may be denied, or the policy may be terminated.`,
    },
    {
      question: `Why might an underwriting application be declined?`,
      ans: `If the underwriting process determines that the risk is too high, coverage may be declined.`,
    },
    {
      question: `How can I check my claim status and records?`,
      ans: `Log in to your personal account on our website, select ‘Claim Records’ from the menu to check your status and history. Of course, you may also contact your dedicated advisor directly for the latest updates or call our hotline for further assistance.`,
    },
    {
      question: `How will I receive my claim payment?`,
      ans: `Claims will be paid according to the payment method selected in your claim form. If no method is specified or the selected option is unavailable, payment will be made via the default method in your personal account.`,
    },
    {
      question: `Who is eligible to file a claim when a covered event occurs?`,
      ans: `Generally, claims can be filed by the policyholder or the insured. However, "death claims" may be submitted by the beneficiary.`,
    },
    {
      question: `How long does it typically take to process a claim?`,
      ans: `Once we receive all required documents listed in the claim form, we typically process the claim within 5 to 10 business days. The actual processing time may vary depending on the claim type, case complexity, and completeness of the submitted information.`,
    },
    {
      question: `How are post-operative injuries and differences in expected outcomes defined?`,
      ans: `For more details, you may consult your dedicated advisor or the collaborating medical institution. You can also log in to your personal client portal on our website to access your policy details.`,
    },
    {
      question: `How can I access my policy documents?`,
      ans: `After your policy is active, you can log in to the personal client portal to view relevant details under your policy page.`,
    }
  ],

  // 联系我们
  contactus_contactUs: 'Contact US',
  contactus_contactUs_desc: `We are here to address your questions 
  and will respond promptly.`,
  contactus_inquiryType: `Inquiry Type`,
  contactus_inquiryType1: `Please Select an Inquiry Type`,
  contactus_inquiryType1Options: [
    'Pre-Surgical Accident Coverage Inquiry',
    'Institutional Liability Coverage Inquiry',
    'Contact your dedicated agent',
    'Policy Benefits Redemption',
    'Business Cooperation',
    'Media Relations',
    'Feedback & Complaints',
    'Others'
  ],
  contactus_countryOptions: [
    'Singapore',
    'Japan',
    'South Korea',
    'Malaysia',
    'Thailand',
    'China',
    'Hong Kong, China',
    'Macau, China',
    'Other Regions',
  ],
  contactus_countryCodeOptions: [
   '+65',
    '+81',
    '+82',
    '+60',
    '+66',
    '+86',
    '+852',
    '+853',
  ],
reset_countryCodeOptions: [
   '+65',
    '+81',
    '+82',
    '+60',
    '+66',
    '+86',
    '+852',
    '+853',
    'Other',
  ],
  contactus_inquiryType2: `Enter Your Inquiry`,
  contactus_contactInformation: `Contact Information`,
  contactus_contactInformation1: `First Name`,
  contactus_contactInformation2: `Last Name`,
  contactus_contactInformation3: `Mr.`,
  contactus_contactInformation4: `Ms.`,
  contactus_contactInformation5: `Country`,
  contactus_contactInformation6: `City`,
  contactus_contactInformation7: `International Dialing Code`,
  contactus_contactInformation8: `Phone number`,
  contactus_submit_protocol: `By clicking the button below, you agree to our <a class="ffen" href="/protocol/private">Privacy Policy</a> and <a class="ffen" href="/protocol/term">Terms of Use</a>.`,
  contactus_submit: `Submit`,
  result_feedback: `Thank you for your message.
We will contact you as soon as we have reviewed your information.`,
  error_required_cannot_empty: 'Required fields cannot be left blank',

  contactus_offices: 'Asia-Pacific Offices',
  contactus_offices_list: [
    { 
      name: 'Singapore', 
      address: `Level 39, Marina Bay Financial Centre Tower 2`, 
      contact: '+65 6565 7722', 
      email: 'sg@assuraasia.com' 
    },
    { 
      name: 'Tokyo', 
      address: `Level 20, Marunouchi Trust Tower Main 1-8-3 Marunouchi Chiyoda-Ku`, 
      contact: '+83 03 5288 6288', 
      email: 'jp@assuraasia.com' 
    },
    { 
      name: 'South Korea', 
      address: `Level 21, Seoul Finance Center, 136 Sejong-daero, Jung-gu`, 
      contact: '+82 2 3888 6789', 
      email: 'kr@assuraasia.com' 
    },
    { 
      name: 'Hong Kong', 
      address: `Level 35, Central Plaza, Hong Kong`, 
      contact: '+852 6567 6688', 
      email: 'hk@assuraasia.com' 
    },
  ],

  // 保障计划
  plan_person: `Pre-Surgery Accident Coverage`,
  plan_person_desc: `Providing effective protection against unforeseen incidents with exceptional underwriting, market insights, and clinical expertise.`,
  plan_unit: `Institutional Liability Coverage`,
  plan_unit_desc: `By combining innovative services and products, we enhance communication and satisfaction between medical institutions and patients, minimizing reputational and financial losses caused by unforeseen incidents.`,
  plan_btn_applynow: `Apply Now`,
  plan_btn_manual: `Manual`,
  
  plan_coverage: `Coverage`,
  plan_coverage_1: `Facial Contouring`,
  plan_coverage_2: `Rhinoplasty`,
  plan_coverage_3: `Eye Surgery`,
  plan_coverage_4: `Breast Enhancement`,
  plan_coverage_5: `Body Shaping`,
  
  plan_person_coverage_list_1_title: `Accidental Death`,
  plan_person_coverage_list_1_desc: `Financial support for families in the rare event of accidental death during a procedure, easing the stress of unforeseen tragedies.`,
  plan_person_coverage_list_2_title: `Functional Impairment`,
  plan_person_coverage_list_2_desc: `Protection against functional impairments caused by procedures, offering compensation to help you recover with confidence.`,
  plan_person_coverage_list_3_title: `Surgical Accidents`,
  plan_person_coverage_list_3_desc: `Coverage for unexpected incidents during surgery, including medical errors or equipment failures, ensuring your rights are protected.`,
  plan_person_coverage_list_4_title: `Satisfaction Guarantee`,
  plan_person_coverage_list_4_desc: `Compensation for surgical errors or unsatisfactory results, with clear and measurable standards to enhance your experience.`,

  plan_unit_coverage_list_1_title: `Medical Liability`,
  plan_unit_coverage_list_1_desc: `Covers compensation and support for patient fatalities from treatment or surgical incidents, including family assistance and reputation management.`,
  plan_unit_coverage_list_2_title: `Functional Impairment`,
  plan_unit_coverage_list_2_desc: `Protection against functional impairments caused by procedures, offering compensation to help you recover with confidence.`,
  plan_unit_coverage_list_3_title: `Surgical Accidents`,
  plan_unit_coverage_list_3_desc: `Coverage for unexpected incidents during surgery, including medical errors or equipment failures, ensuring your rights are protected.`,
  plan_unit_coverage_list_4_title: `Satisfaction Guarantee`,
  plan_unit_coverage_list_4_desc: `Compensation for surgical errors or unsatisfactory results, with clear and measurable standards to enhance your experience.`,

  plan_features: `Program Features`,
  plan_person_features_1_title: `FastPass ™`,
  plan_person_features_1_desc: `Online application service with fast underwriting.`,
  plan_person_features_2_title: `Personal Advisor`,
  plan_person_features_2_desc: `Dedicated one-on-one consultations with expert recommendations.`,
  plan_person_features_3_title: `Customizable Coverage`,
  plan_person_features_3_desc: `Flexible policy options tailored to your unique needs.`,
  plan_person_features_4_title: `Global Concierge Service`,
  plan_person_features_4_desc: `Seamless access to premium healthcare resources across the Asia-Pacific region, always ready to support you.`,

  plan_unit_features_1_title: `FASTPAY™️`,
  plan_unit_features_1_desc: `Streamlined process for fast reimbursement.`,
  plan_unit_features_2_title: `Enhanced Credibility`,
  plan_unit_features_2_desc: `Strengthen patient trust and diversify medical service capabilities.`,
  plan_unit_features_3_title: `Risk Mitigation`,
  plan_unit_features_3_desc: `Effectively manage unexpected incidents, reducing operational pressures.`,
  plan_unit_features_4_title: `Dedicated Team Support`,
  plan_unit_features_4_desc: `Professional assistance to efficiently handle risk events.`,

  plan_moreinfo: `Learn More`,
  plan_moreinfo_desc: `Connect with us through the online contact form and share your needs instantly.`,
  plan_moreinfo_slogan: `Aesthetic Risk Coverage
Confidence When It Matters`,
  plan_moreinfo_nores: `Disclaimer`,
  plan_moreinfo_nores_desc: `Assura Asia and its related companies, affiliates, and subsidiaries disclaim all express and implied warranties, including but not limited to suitability for specific purposes, product display, or recommendation. Users are responsible for evaluating the accuracy, completeness, and usefulness of any opinions, advice, services, or other information provided, or consult legal, medical, or other relevant professionals based on their personal circumstances. Assura Asia and its related companies, affiliates, and subsidiaries shall not be liable for any direct, indirect, special, incidental, or consequential damages arising from the use of the company’s website or any displayed materials.`,

  // 登录
  login_loginType: `Login Type`,
  login_loginType_desc: `Access and Manage Your Coverage or 
  Business Updates`,
  login_loginType_1_title: 'Individual Client',
  login_loginType_1_desc: 'Pre-Surgery Accident Coverage Plan',
  login_loginType_2_title: 'Corporate Client',
  login_loginType_2_desc: 'Pre-Surgery Accident Protection Plan',
  login_loginType_3_title: 'Agent and Broker',
  login_loginType_3_desc: 'Business Management',
  login_forget_password_tip: `Forgot Password? `,
  login_forget_password_find: 'Click here to recover',
  login_noaccount_tip: `No account?`,
  login_regsiter_now: 'Register now',
  login_error_account: 'The username or email is incorrect, please try again',
  login_error_password: 'Wrong password, please try again',

  // 兑换
  exchange_title: 'Redeem Benefits',
  exchange_welcome_txt: 'Welcome back, Oli',
  exchange_loginType_1_title: 'Redeem Card Info',
  exchange_loginType_1_plsholder: 'Redeem Code',
  exchange_loginType_1_error: 'The Redeem Card Info is incorrect. Please try again.',
  exchange_description_title: 'Redemption Instructions',
  exchange_description_txt: ` · Once bound, the redemption card cannot be unbound or used again.
 · Please go to your personal center to redeem the policy.
 · Please contact online support or your advisor for any issues.`,
  exchange_btn: 'Redeem Benefits',

  // 注册
  register_title: 'ACCOUNT',
  register_account: 'Username',
  register_account_tip: '3-20 characters (letters, numbers, _)',
  register_account_exist: '账号已存在，请重试',
  register_email:'Email',
  register_email_tip: 'Invalid format',
  register_email_exist: '邮箱已存在，请重试',
  register_password: 'Password',
  register_password_tip: 'Min 7 chars (A-Z, a-z, 0-9)',
  register_password_tip_mobile:`Min 7 chars (A-Z, a-z, 0-9)`,
  register_password_again: 'Confirm',
  register_password_again_error: 'Passwords must match',
  register_promo_code:'Code',
  register_promo_code_error:'Invalid invitation code',
  next: 'Next',
  register_cancel_btn: 'Cancel',
  placeholder_common: 'Enter',

  //找回密码
  reset_password_title: 'Reset Password',
  reset_password_subtitle: 'Reset via Email or Mobile',
  reset_password_menu: 'Choose Method:',
  reset_password_email: 'Registered email',
  reset_password_mobile:'Registered phone',
  reset_no_account: 'Account not registered',

  //cookie
  cookie_accept_title: 'Cookie Settings',
  cookie_accept_context: 'By clicking "Accept", you agree to the storing of cookies on your device to enhance site navigation, analyze site usage, and assist in our marketing efforts.',
  cookie_accept_btn: 'Accept',
  cookie_reject_btn: 'Reject'
}



